import React, { useState } from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { StringKeyValue } from '../../actions/types';

interface Props {
    text: StringKeyValue;
}

const ExpandableTableItems = ({ text }: Props): JSX.Element => {
    const [expandPrivacy, setExpandPrivacy] = useState(false);

    return (
        <div className="expand-table-items">
            <div className="expand-table-items__header">
                <button
                    className="expand-table-items__button"
                    type="button"
                    onClick={() => setExpandPrivacy(!expandPrivacy)}
                >
                    {text.expandPrivacyTitle}
                    <Icon type={expandPrivacy ? IconTypes.LITEN_PIL_OPP : IconTypes.LITEN_PIL_NED} />
                </button>
            </div>

            {expandPrivacy && (
                <div className="expand-table-items__content">
                    {text.expandPrivacyText1 && <p>{text.expandPrivacyText1}</p>}
                    {text.expandPrivacyText2 && <p>{text.expandPrivacyText2}</p>}
                    {text.expandPrivacyText3 && <p>{text.expandPrivacyText3}</p>}
                    {text.expandPrivacyText4 && <p>{text.expandPrivacyText4}</p>}
                    {text.expandPrivacyText5 && (
                        <p>
                            <Link href={text.expandPrivacyText5Url}>{text.expandPrivacyText5}</Link>
                        </p>
                    )}
                    {text.expandPrivacyText6 && <p>{text.expandPrivacyText6}</p>}
                </div>
            )}
        </div>
    );
};

export default ExpandableTableItems;
